export enum MenuBarButtonType {
    SELECT_ALL = 'SELECT_ALL',
    MAIL_REPLY = 'MAIL_REPLY',
    MAIL_FORWARD = 'MAIL_FORWARD',
    MAIL_SEND = 'MAIL_SEND',
    MAIL_ARCHIVE = 'MAIL_ARCHIVE',
    MOVE_TO_FOLDER = 'MOVE_TO_FOLDER',
    MAIL_DELETE = 'MAIL_DELETE',
    MORE_ACTIONS = 'MORE_ACTIONS',
    MAIL_PRINT = 'MAIL_PRINT',
    CLOSE = 'CLOSE',
    SAVE = 'SAVE',
    ADD_EDIT_NOTE = 'ADD_EDIT_NOTE',
    MORE_INFORMATION = 'MORE_INFORMATION',
    FOLDER_ACTION = 'FOLDER_ACTION',
    MARK_AS_READ = 'MARK_AS_READ',
    MARK_AS_UNREAD = 'MARK_AS_UNREAD',
    FORWARD_SEND = 'FORWARD_SEND',
    FORWARD_DISCARD = 'FORWARD_DISCARD',
    SORT_FILTER = 'SORT_FILTER',
    CUSTOM_LIST = 'CUSTOM_LIST',
    ORGANIZATION_CATEGORY = 'ORGANIZATION_CATEGORY',
}

export enum SelectAllItems {
    NONE = '',
    CHECK_ALL = '0',
    CHECK_UNREAD = '1',
    CHECK_READ = '2',
    UNCHECK_ALL = '3',
    CHECK_FLAG_ADD = '4',
    CHECK_FLAG_REMOVE = '5',
}

export enum MoveToFolderItems {
    STATIC = '0',
    CUSTOM_FOLDERS = '1',
    MOVE_MAILS_TO_OTHER_FOLDER = '2',
    MOVE_MAILS_TO_NEW_FOLDER = '3',
}

export enum MoreActionsItems {
    VIEW_CORRESPONDENCE = '0',
    DOWNLOAD = '1',
    TEXT_PRINT = '2',
    RENAME_MAILS = '3',
    FORWARD = '4',
    ARCHIVE = '5',
    ADD_NOTE = '6',
    EDIT_NOTE = '7',
    INFORMATION = '8',
    MARK_AS_READ = '9',
    MARK_AS_UNREAD = '10',
    ADD_FLAG = '11',
    REMOVE_FLAG = '12',
    DELETE = '13',
    REPLY = '14',
    SAVE = '15',
}

export enum CustomActionsItem {
    ATTACHMENT = '0',
}
